import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { BaseAddressModel, PaginationModel } from "@insite/client-framework/Types/ApiModels";
import CustomerCard, { CustomerCardStyles } from "@insite/content-library/Components/CustomerCard";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { hasSelectedShippingAddress } from "@tSurya/Common/Utilities/checkoutShippingValidation";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";
import React, { useState } from "react";
import { connect } from "react-redux";

interface OwnProps {
    customers: BaseAddressModel[];
    pagination: PaginationModel | null;
    selectedCustomer?: BaseAddressModel;
    onSelect: (customer: BaseAddressModel) => void;
    /** @deprecated Not used anymore */
    allowEditCustomer?: boolean;
    onEdit?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, customer: BaseAddressModel) => void;
    onChangePage: (page: number) => void;
    onChangeResultsPerPage: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    extendedStyles?: CustomerSelectorStyles;
    isOverlay?: boolean;
}
const mapStateToProps = (state: CustomApplicationState) => ({
    hasSelectedAddress: hasSelectedShippingAddress(state),
});
type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface CustomerSelectorStyles {
    customerCard?: CustomerCardStyles;
    customerCardSelected?: CustomerCardStyles;
    pagination?: PaginationPresentationProps;
}

const linkTextStyles: TypographyPresentationProps = {
    color: "text.main",
};

export const customerSelectorStyles: CustomerSelectorStyles = {
    customerCardSelected: {
        address: {
            attentionText: linkTextStyles,
            customerNameText: linkTextStyles,
            companyNameText: linkTextStyles,
            address1Text: linkTextStyles,
            address2Text: linkTextStyles,
            address3Text: linkTextStyles,
            address4Text: linkTextStyles,
            cityStatePostalCodeText: linkTextStyles,
            countryText: linkTextStyles,
            phoneText: linkTextStyles,
            emailText: linkTextStyles,
            faxText: linkTextStyles,
        },
    },
};

const CustomerSelector: React.FC<Props> =({
    customers,
    pagination,
    extendedStyles,
    selectedCustomer,
    isOverlay,
    onChangePage,
    onChangeResultsPerPage,
    onSelect,
    onEdit,
    hasSelectedAddress,
}: Props) => {
    const [styles] = useState(() => mergeToNew(customerSelectorStyles, extendedStyles));
    return (
        <>
            {customers.map(customer => {
                const isCardSelected = customer.id === selectedCustomer?.id && hasSelectedAddress;
                return (
                    <CustomerCard
                        key={customer.id}
                        customer={customer}
                        isSelected={isCardSelected}
                        extendedStyles={isCardSelected ? styles.customerCardSelected : styles.customerCard}
                        onSelect={onSelect}
                        onEdit={onEdit}
                        isOverlay={isOverlay}
                    />
                );
            })}
            {customers.length > 0 && pagination && (
                <Pagination
                    {...styles.pagination}
                    currentPage={pagination.currentPage}
                    resultsPerPage={pagination.pageSize}
                    resultsCount={pagination.totalItemCount}
                    resultsPerPageOptions={pagination.pageSizeOptions}
                    onChangePage={onChangePage}
                    onChangeResultsPerPage={onChangeResultsPerPage}
                    prevPage={pagination.prevPageUri}
                    nextPage={pagination.nextPageUri}
                />
            )}
        </>
    );
};

export default connect(mapStateToProps) (CustomerSelector);
